// extracted by mini-css-extract-plugin
export default {"section":"About_section__O1rjF"};